import React, { useEffect, useState } from 'react'
import { Color, LuxIcon } from '@lux/wardrobe-lib'
import { useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import { MenuItemCode } from '../smart-sidebar/menu-items'
import './smart-submenu.scss'
import { canViewReports, layoutActions, ModalsType } from '@Techedge/digitalportal-shared'

const SmartSubMenu = (props: {
    token?: string
    grsdToken: string
    basePath: string
    subMenuItems: {
        title: string
        icon: string
        path: string
        code?: string
        visible?: boolean
    }[]
    permissions
    onChildClick: (code: string) => void
    openGrsd: (token: string) => void
}) => {
    const {
        subMenuItems,
        basePath,
        token,
        permissions,
        grsdToken,
        onChildClick,
        openGrsd,
    } = props

    const intl = useIntl()

    const navigate = useNavigate()
    const [showProfileMGMT, setShowProfileMGMT] = useState<boolean>()

    const renderMenuItem = (subMenuItem, i: number) => {
        const isStore360Link = subMenuItem?.code === MenuItemCode.OLD_STORE360
        if (subMenuItem?.code === MenuItemCode.SMARTLY_REPORT && !canViewReports()) {
            return
        }

        if (
            subMenuItem?.code === MenuItemCode.SMARTLY_PROFILE_MGMT &&
            !showProfileMGMT
        )
            return

        // if (subMenuItem?.code === MenuItemCode.SMARTLY_GRSD) {
        //     return (
        //         <div key="grsd" className="submenu-item">
        //             <LuxIcon
        //                 size={20}
        //                 color={Color.BLACK}
        //                 icon={subMenuItem.icon}
        //             />
        //             <a
        //                 className="p-accordion-header-link"
        //                 target="out"
        //                 href={`${process.env.GRSD_URL}?code=${grsdToken}&target=out`}>
        //                 GRSD
        //             </a>
        //         </div>
        //     )
        // }
        return (
            subMenuItem?.icon && (
                <div
                    key={i}
                    onClick={() => {
                        if (subMenuItem?.code === MenuItemCode.SMARTLY_GRSD) {
                            openGrsd(grsdToken)
                            return
                        }
                        if (isStore360Link) {
                            if ((window as any)?.webkit?.messageHandlers) {
                                try {
                                    ;(
                                        window as any
                                    ).webkit.messageHandlers.goToOld.postMessage(
                                        'goToOld'
                                    )
                                } catch (error) {
                                    console.error('ERROR goToOld', error)
                                }
                            } else {
                                window.location.href = `${process.env.STORE_360_URL}?jwt=${token}`
                            }
                            return
                        }
                        onChildClick(subMenuItem.code)
                        navigate(
                            subMenuItem.path === '/profile-mgmt'
                                ? `${basePath}${subMenuItem.path}`
                                : subMenuItem.path
                        )
                    }}
                    className={`submenu-item${
                        isStore360Link ? ' store360-link' : ''
                    }`}>
                    <LuxIcon
                        size={20}
                        color={Color.BLACK}
                        icon={subMenuItem.icon}
                    />
                    <label>
                        {intl.formatMessage({
                            id: `sidebar.menuItem.code.${subMenuItem.code}`,
                            defaultMessage: subMenuItem.title,
                        })}
                    </label>
                </div>
            )
        )
    }

    useEffect(() => {
        if (permissions?.length) {
            let can = permissions.find((p) => p.actionName === 'editprofiles')
            setShowProfileMGMT(!!can)
        }
    }, [permissions])

    return (
        <div
            id="smart-submenu"
            style={
                location.pathname.includes('profile') ? { display: 'none' } : {}
            }>
            <div className="submenu-content">
                {subMenuItems &&
                    subMenuItems?.length > 0 &&
                    subMenuItems?.map(renderMenuItem)}
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    token: state.userReducer.accessToken,
})

const mapDispatchToProps = (dispatch) => ({
    openGrsd: (grsdToken) => {
        dispatch(
            layoutActions.setModals({
                type: ModalsType.GRSD,
                props: { grsdToken },
            })
        )
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(SmartSubMenu)
